// CATEGORY
export const CATEGORY_SET_REQUEST = 'CATEGORY_SET_REQUEST';
export const CATEGORY_SET_SUCCESS = 'CATEGORY_SET_SUCCESS';
export const CATEGORY_SET_ERROR = 'CATEGORY_SET_ERROR';
export const CATEGORY_SET_CATEGORIES = 'CATEGORY_SET_CATEGORIES';
export const CATEGORY_GET_CATEGORIES = 'CATEGORY_GET_CATEGORIES';
export const CATEGORY_SET_CATEGORY = 'CATEGORY_SET_CATEGORY';
export const CATEGORY_GET_CATEGORY = 'CATEGORY_GET_CATEGORY';
